var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic-assistant-page"},[(_vm.selectedTool)?_c('TopicAssistant',{attrs:{"greetingMsg":_vm.selectedTool.label,"curInfoToolTipMsg":_vm.selectedTool.intro,"conversationId":_vm.conversationId,"toolIdx":_vm.toolIdx,"toolList":_vm.toolList},on:{"close_tool":_vm.goToAcademicSearch}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }